// 关键地址页面翻译
export default {
  // 输入框占位符
  placeholders: {
    address: "请输入地址",
    blockchain: "请选择主链",
    canvas: "请选择画布",
  },

  // 按钮
  buttons: {
    reset: "重置",
    search: "查询",
    edit: "修改",
    delete: "删除",
  },

  // 统计信息
  statistics: {
    total: "共计",
    totalData: "条数据",
  },

  // 表格列标题
  table: {
    index: "序号",
    address: "地址",
    blockchain: "公链",
    balance: "余额（折合USDT）",
    remark: "备注",
    relatedCanvas: "关联画布",
    creator: "创建人",
    createTime: "创建时间",
    action: "操作",
  },

  // 对话框
  dialogs: {
    title: "删除确认",
    deleteConfirm: "是否确认删除该地址?",
  },

  // 提示信息
  messages: {
    noData: "暂无数据",
    deleteSuccess: "删除成功",
    deleteCancelled: "已取消删除",
    markSuccess: "标记成功",
    copySuccess: "复制成功",
    loading: "拼命加载中",
  },

  // 确认按钮
  confirm: {
    ok: "确定",
    cancel: "取消",
  },

  // 编辑备注弹窗
  editDialog: {
    title: "编辑备注",
    label: "备注",
    placeholder: "请输入修改备注(必填)",
    validation: {
      required: "备注为必填项",
    },
    buttons: {
      reset: "重置",
      confirm: "确认",
    },
    messages: {
      editSuccess: "修改成功",
    },
  },
};
